export function createCalculatorModelRequestLifecycle(onMissingCarrier) {
  if (typeof onMissingCarrier !== "function") {
    throw new TypeError("calculator model request lifecycle requires a missing-carrier handler");
  }
  let activeCount = 0;
  const startedRequestIds = new Set();
  return Object.freeze({
    reset() {
      activeCount = 0;
      startedRequestIds.clear();
    },
    accept(detail, pendingRequestId) {
      if (detail === null || typeof detail !== "object" || Array.isArray(detail)) {
        return false;
      }
      if (detail.type === "started") {
        activeCount += 1;
        if (typeof pendingRequestId === "string") {
          startedRequestIds.add(pendingRequestId);
        }
        return true;
      }
      if (detail.type !== "finished" || activeCount === 0) {
        return false;
      }
      activeCount -= 1;
      if (activeCount !== 0) {
        return true;
      }
      const finishedWithoutCarrier = (
        typeof pendingRequestId === "string"
        && startedRequestIds.has(pendingRequestId)
      );
      startedRequestIds.clear();
      if (finishedWithoutCarrier) {
        onMissingCarrier(pendingRequestId);
      }
      return true;
    },
  });
}
